import { Grid } from "@mui/material";

const Settings = () => {

  return (
    <div>Settings</div>
  )
  
};

export default Settings;